export default __webpack_public_path__ + "static/media/Doribac-250-ban.7b6f5575.jpg";